import React from "react";
import { useNavigate } from "react-router-dom";
import UseContext from "hooks/useContext";
import { ChevronRight, Close } from "assets/icons";

const TEMPLATE_PAGES = [
    "Secteur d'activité",
    "Pré-requis",
    "Lieu & Rémunération",
    "Informations supp.",
    "Confirmation",
];

const TemplateSubNav = () => {
    const navigate = useNavigate();
    const { templatePage, setTemplatePage, resetTemplateData } = UseContext();

    const handleClose = (e) => {
        e.preventDefault();
        const confirmed = window.confirm(
            "Êtes-vous sûr de vouloir quitter la page ? Vos modifications ne seront pas enregistrées."
        );
        if (confirmed) {
            resetTemplateData();
            navigate("/missionTemplates");
        }
    };

    /** Libellés alignés sur templatePage 1…5 (voir templateFormsCreate). */
    const goToStep = (zeroBasedIndex) => {
        const step = zeroBasedIndex + 1;
        if (step < 1 || step > TEMPLATE_PAGES.length) return;
        if (zeroBasedIndex >= templatePage - 1) return;
        setTemplatePage(step);
    };

    if (templatePage <= 0 || templatePage > TEMPLATE_PAGES.length) {
        return null;
    }

    return (
        <div
            className={
                "flex justify-between px-5 gap-3 border-b select-none min-h-[66px] max-h-[66px]"
            }
        >
            <div
                className={
                    "my-auto flex gap-1 whitespace-nowrap overflow-x-auto no-scrollbar ft-sm pr-5 py-4"
                }
            >
                {TEMPLATE_PAGES.map((label, index) => {
                    const isCurrent = templatePage - 1 === index;
                    const isVisitedPast = templatePage - 1 > index;
                    const clickable = isVisitedPast;

                    const tabClassName = `my-auto py-2 px-3 border rounded-lg text-left ${
                        isCurrent
                            ? "bg-yellow-50 border-yellow-300 text-yellow-500"
                            : isVisitedPast
                              ? "bg-yellow-50 text-yellow-500 border-white"
                              : "bg-gray-50 border-white"
                    } ${clickable ? "cursor-pointer hover:bg-yellow-100/80 transition-colors" : ""}`;

                    return (
                    <div key={index} className={"flex items-center gap-1"}>
                        {clickable ? (
                            <button
                                type="button"
                                className={tabClassName}
                                onClick={() => goToStep(index)}
                                title="Revenir à cette étape"
                            >
                                {label}
                            </button>
                        ) : (
                            <div className={tabClassName}>
                                {label}
                            </div>
                        )}
                        {index < TEMPLATE_PAGES.length - 1 && (
                            <div className={"my-auto"}>
                                <ChevronRight wh={16} color={"#6B7280"} />
                            </div>
                        )}
                    </div>
                    );
                })}
            </div>
            <div className={"my-auto flex gap-2 py-4 border-l pl-3"}>
                <button
                    type="button"
                    className={
                        "cursor-pointer border rounded p-1 hover:bg-gray-50"
                    }
                    onClick={handleClose}
                    aria-label="Quitter la création de fiche de poste"
                >
                    <Close wh={20} color={"#374151"} />
                </button>
            </div>
        </div>
    );
};

export default TemplateSubNav;
